import _ from 'lodash'

export const getTitleWithDeskCount = space => {
  let pax = _.get(space, 'reservable.capacity') || _.get(space, 'metrics.desks')

  // Check 0, '0', ''
  if (pax === 0 || pax === '0' || !pax) {
    pax = ''
  }

  if (pax) {
    pax += 'd'
  }
  return [`${space.number}`, pax].join('\n').trim()
}

const generateSpaceText = spaces => {
  const mapping = {}
  spaces.forEach(space => {
    mapping[space.uuid] = getTitleWithDeskCount(space)
  })
  return mapping
}

export default generateSpaceText
